import { postData } from '../helpers/ajax'

export default function gradeExam () {
  const questions = [...document.querySelectorAll('.Question')]
  const checkExamButton = document.querySelector('.js-exam-submit-button')
  const retakeExamButton = document.querySelector('.js-exam-retake-button')

  if (checkExamButton) {
    // Disable submit button and add text
    checkExamButton.disabled = true
    checkExamButton.classList.add('Button--disabled')
    checkExamButton.setAttribute('title', 'Du måste svara på alla frågor för att kunna skicka in dina svar')

    // Check on input change if all questions are answered
    // If they are, re-enable submit button
    const examForm = document.getElementById('exam-form')
    examForm.addEventListener('change', () => {
      let validForm = true

      questions.forEach(question => {
        const answersInputs = [...question.querySelectorAll('.AnswersListItem-input')]
        const answered = answersInputs.find(answer => answer.checked)
        if (!answered) {
          validForm = false
        }
      })
 
      if (validForm) {
        checkExamButton.disabled = false
        checkExamButton.classList.remove('Button--disabled')
        checkExamButton.setAttribute('title', 'Skicka in dina svar')
      }
    })

    const examFeedbackPass = document.querySelector('.ExamFeedback--pass')
    const examFeedbackFail = document.querySelector('.ExamFeedback--fail')
    examForm.addEventListener('submit', async (evt) => {
      evt.preventDefault()
      try {
        const answers = []
        questions.forEach(question => {
          const answersInputs = [...question.querySelectorAll('.AnswersListItem-input')]
          const answered = answersInputs.find(answer => answer.checked)
          if (answered) {
            answers.push({
                postId: question.dataset.postid,
                answer: answered.value
              }
            )
          } else {
            throw('Svara på alla frågor!')
          }
        })

        const formData = new FormData()
        formData.append('action', 'check_exam')
        formData.append('exam_id', document.getElementById('examId').value)
        formData.append('answers', JSON.stringify(answers))
        const response = await postData(barnafrid.ajax_url, formData)
        response.results.forEach(result => {
          const resultId = parseInt(result.ID)
          const answeredQuestion = questions.find(question => parseInt(question.dataset.postid) === resultId)
          const questionFeedback = answeredQuestion.querySelector('.QuestionFeedback')
          const answers = [...answeredQuestion.querySelectorAll('.AnswersListItem-input')]
          answeredQuestion.classList.add('Question--answered')
          answers.forEach(answer => {
            answer.disabled = true
            if (answer.value === result.answered) {
              if (answer.value === result.correctAnswer) {
                answer.parentNode.classList.toggle('AnswersListItem-answer--correct')
                questionFeedback.classList.toggle('QuestionFeedback--correct')
              } else {
                answer.parentNode.classList.toggle('AnswersListItem-answer--incorrect')
                questionFeedback.classList.toggle('QuestionFeedback--incorrect')
              }
            } else {
              if (answer.value === result.correctAnswer) {
                answer.parentNode.classList.toggle('AnswersListItem-answer--right')
              }
            }
          })
          questionFeedback.innerHTML = result.answerText
        })
        if (response.passedExam) {
          examFeedbackPass.classList.add('is-visible')
          examFeedbackPass.querySelector('.js-result-correct').textContent = response.score
          examFeedbackPass.querySelector('.js-result-total').textContent = response.numberOfQuestions
        } else {
          examFeedbackFail.classList.add('is-visible')
          examFeedbackFail.querySelector('.js-result-correct').textContent = response.score
          examFeedbackFail.querySelector('.js-result-total').textContent = response.numberOfQuestions
          retakeExamButton.classList.remove('is-hidden')
        }
        window.scroll(0, 0)
        checkExamButton.remove()
      } catch (err) {
        console.log(err)
      }
    })
  }
}
